import { IsInAuthor, IsPreviewGenerator } from "../../state/ui";

import { IsInPlayWrightTest } from "../../state/page";
import { NavigationType } from "../../state/navigation";
import { ReadingRulerMode } from "../../state/accessibility";
import PreviewElements from "./PreviewElements";
import ScrollElements from "./ScrollElements";
import TapElements from "./TapElements";
import { createContext } from "react";
import gsap from "gsap";
import { useGSAP } from "@gsap/react";
import { useRecoilValue } from "recoil";

gsap.registerPlugin(useGSAP);

export const GridContext = createContext(false);

// which navigation position the elements are in
export type PositionContextType = "top" | "bottom" | "left" | "right";
export const PositionContext = createContext<PositionContextType>("left"); // default to tap

export const ScrollTimeline = createContext<GSAPTimeline | undefined>(
	undefined,
);

export const PageTimelineContext = createContext<
	gsap.core.Timeline | undefined
>(undefined);

function DisplayElements(): JSX.Element {
	const navigationType = useRecoilValue(NavigationType);
	const isPreviewer = useRecoilValue(IsPreviewGenerator);
	const isInPlayWrightTest = useRecoilValue(IsInPlayWrightTest);
	const isInAuthor = useRecoilValue(IsInAuthor);
    const isReadingRuler = useRecoilValue(ReadingRulerMode);

	const { contextSafe } = useGSAP();
	// Create separate timelines for scroll-linked and element-specific animations
	const scrollTimeline = contextSafe(gsap.timeline);

	if (isPreviewer || isInPlayWrightTest || isInAuthor || isReadingRuler) {
		return <PreviewElements />;
	}
	if (
		navigationType === "scroll" ||
		navigationType === "scrollCards" ||
		navigationType === "scrollContinuous"
	) {
		return (
			<ScrollTimeline.Provider value={scrollTimeline()}>
				<ScrollElements />
			</ScrollTimeline.Provider>
		);
	}

	if (navigationType === "tap") {
		return <TapElements />;
	}

	return <></>;
}

export default DisplayElements;
